<template>
  <div class="serviceContractMag">
    <el-container>
      <el-header>
        <div style="width: 100%; background: #d5e7ed">
          <el-tabs
            v-model="activeName"
            type="card"
            @tab-click="handleTabClick"
            style="width: 100%"
          >
            <el-tab-pane label="全部" name="first"></el-tab-pane>
            <el-tab-pane label="待审核" name="second"></el-tab-pane>
            <el-tab-pane label="已通过" name="third"></el-tab-pane>
            <el-tab-pane label="已驳回" name="fourth"></el-tab-pane>
          </el-tabs>
        </div>
        <QueryHeader @queryData="handleClick" :type="type"></QueryHeader>
        <el-col :span="24" style="padding: 0 20px">
          <div class="operatePanel">
            <el-button
              type="primary"
              v-if="btnAuthorize.addBtn.btnEnable"
              icon="el-icon-plus"
              @click="createContract()"
              >新建</el-button
            >
            <el-button
              type="primary"
              v-if="btnAuthorize.modBtn.btnEnable"
              icon="el-icon-plus"
              @click="editContract()"
              >修改</el-button
            >
            <el-button
              type="primary"
              v-if="btnAuthorize.delBtn.btnEnable"
              icon="el-icon-delete"
              @click="DelectContract()"
              >删除</el-button
            >
            <el-button
              type="primary"
              v-if="btnAuthorize.callback.btnEnable"
              icon="el-icon-plus"
              @click="CallBackContract()"
              >撤回</el-button
            >
            <el-button
              title="追加补充协议"
              type="primary"
              v-if="btnAuthorize.addprotocol.btnEnable"
              icon="el-icon-upload2"
              @click="addSupplementary()"
              >追加补充协议</el-button
            >
            <el-button
              title="上传合同扫描件"
              type="primary"
              v-if="btnAuthorize.uploadcontractfile.btnEnable"
              icon="el-icon-upload2"
              @click="uploadContractFile()"
              >上传合同扫描件</el-button
            >
            <el-button
              title="导出当前列表查询出的数据，列表显示字段即为导出表格中数据字段。"
              type="primary"
              v-if="btnAuthorize.export.btnEnable"
              icon="el-icon-download"
              @click="exportCurrentList()"
              >导出</el-button
            >
            <el-button
              title="导出当前列表查询出的数据，列表显示字段即为导出表格中数据字段。"
              type="primary"
              v-if="btnAuthorize.export.btnEnable"
              icon="el-icon-download"
              @click="exportAllCurrentList()"
              >导出全部</el-button
            >
          </div>
        </el-col>
      </el-header>
      <el-main ref="main">
        <el-table
          ref="multipleTable"
          :data="tableData"
          border
          size="mini"
          style="width: 100%"
          height="100%"
          @selection-change="handleSelectionChange"
          @row-click="rowClicked"
          @cell-dblclick="ServiceContractDetail"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column
            v-for="(item, index) in tableColumnDatas"
            :key="index"
            :prop="item.class"
            :label="item.labelName"
            :sortable="item.sortEnable"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="item.isNumFilter">{{
                scope.row[scope.column.property] | numFilter
              }}</span>
              <span v-else>{{ scope.row[scope.column.property] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <div style="display: flex; justify-content: space-between">
          <span
            style="
              color: #666666;
              font-size: 14px;
              line-height: 32px;
              margin-top: 16px;
            "
            >显示{{
              totalCount > 0
                ? (currentPage - 1) * pageSize +
                  1 +
                  "-" +
                  (currentPage * pageSize > totalCount
                    ? totalCount
                    : currentPage * pageSize)
                : "0"
            }}，共{{ totalCount }}条记录</span
          >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          ></el-pagination>
        </div>
      </el-footer>
    </el-container>
    <!-- 导入分项合同扫描件 -->
    <upload-dialog
      :isShow="showUploadDialog"
      :subContractId="subContractId"
      @close="closeDialogAction"
      :isImportContract="isImportContractDialog"
    />
  </div>
</template>

<script>
import UploadDialog from "./commonCell/UploadDialog"; //导入总包合同组件
import {
  exportExcelService2, //导出
  getContractCodeByUserCodeService, //获取总包合同编码接口
  getSubServicesContractList, //获取劳务合同列表接口
  deleteOneSubServiceContractSevice, //删除一条劳务合同数据
  exportServicesContractList, //导出总包合同接口
  exportsubContractList, ///根据查询条件导出分项合同
} from "../../services/allContractServices";
import QueryHeader from "./subContract/header";
import { recallApproveItemFun } from "@/page/approveComponents/approve";

export default {
  name: "serviceContractMag",
  components: {
    UploadDialog,
    QueryHeader,
  },
  props: {
    menuCode: {
      type: String,
    },
  },
  data() {
    return {
      activeName: "first",
      contractCodeList: [], //合同编码
      partyBList: [], //供应商（合同乙方名称）
      belongProjectList: [], //所属项目
      selectItems: [], //记录选中的总包合同行
      subContractId: null,
      showUploadDialog: false, //导入总包合同对话框展示与否
      isImportContractDialog: false, //false 为导入合同扫描件，true为导入总包合同
      category: "SUB_CONTRACT_SERIAL_NUMBER", //下拉列表类型
      //查询条件form
      Contractform: {},
      type: "LABOR", //分项合同类型，LABOR劳务 MATERIAL材料  MACHINE机械 3 机械 OTHERS其它
      tabIndex: 0, //全部0待审核1通过2拒绝3
      tableColumnDatas: [
        { class: "serialNumber", labelName: "合同编号", sortEnable: false },
        { class: "name", labelName: "合同名称", sortEnable: false },
        { class: "projectName", labelName: "所属项目", sortEnable: false },
        { class: "partyB", labelName: "供应商", sortEnable: false },
        {
          class: "amount",
          labelName: "合同金额",
          sortEnable: false,
          isNumFilter: true,
        },
        { class: "signDate", labelName: "签订日期", sortEnable: false },
        { class: "applyUserName", labelName: "申请人", sortEnable: false },
        { class: "applyDeptName", labelName: "申请部门", sortEnable: false },
        { class: "approveStatusName", labelName: "状态", sortEnable: false },
      ],
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      tableData: [],
      compList: [],
      posts: [], //岗位数组
      showExportDialog: false,
      btnAuthorize: {
        addBtn: { key: "create", btnEnable: false },
        modBtn: { key: "update", btnEnable: false },
        delBtn: { key: "delete", btnEnable: false },
        callback: { key: "callback", btnEnable: false }, //撤回
        export: { key: "export", btnEnable: false }, //导出
        addprotocol: { key: "addprotocol", btnEnable: false }, //追加补充协议
        uploadcontractfile: { key: "uploadcontractfile", btnEnable: false }, //上传合同附件
      },
    };
  },
  methods: {
    onActive(menuCode) {
      this.Contractform.id = this.tabRouteParam?.id ?? "";
      this.Contractform.type = this.type;
      this.activeName = "first";
      this.tabIndex = "0";
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.initList(); //获取下拉列表  gaa 20200806
    },
    // mounted() {
    //   this.activeName = "first";
    //   this.initList(); //获取下拉列表  gaa 20200806
    // },
    //点击查询
    handleClick(Contractform) {
      this.Contractform.id = "";
      this.currentPage= 1;
      this.pageSize = 20;
      this.Contractform = Contractform;
      this.initList();
    },
    //审批关闭
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },

    //获取category下拉框数据
    getContractCode(category) {
      let param = {};
      param.category = category;
      getContractCodeByUserCodeService(param)
        .then((res) => {
          if (res.code == 10000000) {
            if (category == "GENERAL_CONTRACT_SERIAL_NUMBER") {
              this.contractCodeList = res.data; //总包合同编码
            } else if (category == "SUB_CONTRACT_PARTYB") {
              this.partyBList = res.data; //合同乙方
            } else {
              this.belongProjectList = res.data; //所属项目
            }
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {});
    },

    initList() {
      let param = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        tabIndex: this.tabIndex,
      };
      for (let key in this.Contractform) {
        if (this.Contractform[key] !== "" && this.Contractform[key] !== 0) {
          param[key] = this.Contractform[key];
        }
      }
      if (this.Contractform.signDate && this.Contractform.signDate.length > 1) {
        param.signDateStart = this.Contractform.signDate[0];
        param.signDateEnd = this.Contractform.signDate[1];
        delete param.signDate;
      }
      getSubServicesContractList(param, true)
        .then((res) => {
          if (res.code == 10000000) {
            this.dealTableData(res);
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    }, //
    dealTableData(res) {
      this.tableData = res.data;
      this.tableHeight = this.$refs.main.$el.offsetHeight - 10;
      this.totalCount = res.total;
    }, //

    onSearch() {
      this.currentPage = 1;
      this.initList();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initList();
    }, //
    handleCurrentChange(page) {
      this.currentPage = page;
      this.initList();
    },
    //选中的劳务分项合同
    handleSelectionChange(val) {
      if (val.length) {
        this.selectItems = val;
        this.subContractId = val[0].id;
      }
    }, //
    // 点击选中行
    rowClicked(row, event, column) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    //双击跳转劳务合同详情
    ServiceContractDetail(row, column, cell, event) {
      this.bus.$emit("tabClose", "totalApproveList");
      this.$nextTick(() => {
        this.bus.$emit("navMenuChange", {
          routeId: "totalApproveList",
          routeParam: {
            id: row.id,
            routeId: "totalApproveList",
            uploadBtn: this.btnAuthorize.uploadcontractfile.btnEnable,
          },
        });
      });
    },
    //tab页切换
    handleTabClick(tab, event) {
      // console.log(tab, event);
      // this.clearSearchConditions();
      this.currentPage = 1;

      switch (this.activeName) {
        case "first":
          this.tabIndex = "0";
          break;
        case "second":
          this.tabIndex = "1";
          break;
        case "third":
          this.tabIndex = "2";
          break;
        case "fourth":
          this.tabIndex = "3";
          break;
        default:
          this.status = "0";

          break;
      }
      this.initList();
    },

    //根据查询条件导出全部分项合同
    exportAllCurrentList() {
      let param = {
        tabIndex: this.tabIndex,
      };
      for (let key in this.Contractform) {
        if (this.Contractform[key] !== "") {
          param[key] = this.Contractform[key];
        }
      }
      if (this.Contractform.signDate && this.Contractform.signDate.length > 1) {
        param.signDateStart = this.Contractform.time[0];
        param.signDateEnd = this.Contractform.time[1];
        delete param.signDate;
      }
      exportsubContractList(param)
        .then((res) => {
          if (res.code == 10000000) {
            exportExcelService2(res.data).then((res1) => {
              this.$alert("导出成功", "提示", {
                confirmButtonText: "确定",
              });
            });
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch(() => {});
    },

    //导出分项合同列表
    exportCurrentList() {
      if (this.selectItems.length < 1) {
        this.$alert("请选择要导出的数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let param = {};
      param.exportIds = new Array();
      for (let i = 0; i < this.selectItems.length; i++) {
        param.exportIds[i] = this.selectItems[i].id;
      }
      exportServicesContractList(param.exportIds.toString())
        .then((res) => {
          if (res.code == 10000000) {
            exportExcelService2(res.data).then((res1) => {
              this.$alert("导出成功", "提示", {
                confirmButtonText: "确定",
              });
            });
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch(() => {});
    },

    //跳转到创建劳务合同界面
    createContract() {
      let memberData = {};
      memberData.editFlag = false; //新增标志为0
      memberData.type = this.type;
      this.bus.$emit("navMenuChange", {
        routeId: "modQuestionnaire",
        routeParam: memberData,
      });
    },
    //跳转到修改劳务合同界面
    editContract() {
      if (this.selectItems.length != 1) {
        this.$alert("请选择一条数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      if (
        this.selectItems[0].approveStatus != 1 &&
        this.selectItems[0].approveStatus != 4 &&
        this.selectItems[0].approveStatus != 0
      ) {
        this.$alert("只有 撤回/驳回/已保存 状态的合同可以修改", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let memberData = {};
      memberData.editFlag = true; //编辑标志为1
      memberData.id = this.selectItems[0].id; //选中行
      memberData.type = this.type;
      this.bus.$emit("navMenuChange", {
        routeId: "roomBindingSta",
        routeParam: memberData,
      });
    },
    //删除总包合同
    DelectContract() {
      if (this.selectItems.length != 1) {
        this.$alert("请选择一条数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }

      let param = {};
      param.delIds = this.selectItems[0].id;
      this.$confirm("确认删除该条劳务合同数据吗?", "提示", {
        confirmButtonText: "确认",
      }).then(() => {
        deleteOneSubServiceContractSevice(param)
          .then((res) => {
            if (res.code == 10000000) {
              this.$alert("删除成功", "提示", {
                confirmButtonText: "确定",
              });
              this.initList();
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$message.error("网络请求失败");
          });
      });
    },

    //撤回一条劳务合同
    CallBackContract() {
      if (this.selectItems.length != 1) {
        this.$alert("请选择一条数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }

      let param = {
        itemId: this.selectItems[0].id,
        type: "SUB_CONTRACT",
      };
      this.$confirm("确认撤回该条分项合同数据吗?", "提示", {
        confirmButtonText: "确认",
      }).then(async () => {
        let res = await recallApproveItemFun(param);
        if (res && res.code == 10000000) {
          this.$message.success("撤回成功");
          this.initList();
        }
      });
    },

    //追加补充协议
    addSupplementary() {
      if (this.selectItems.length != 1) {
        this.$alert("请选择一条数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      if (this.selectItems[0].approveStatus != 3) {
        this.$alert("该分项合同未审批通过，不能追加补充协议", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      this.$confirm("确认追加补充协议吗?", "提示", {
        confirmButtonText: "确认",
      }).then(() => {
        let memberData = {};
        memberData.editFlag = false; //新增标志为0
        memberData.id = this.selectItems[0].id;
        memberData.addFlag = 1; //1 补充追加协议 2编辑补充协议
        memberData.type = this.type;
        this.bus.$emit("navMenuChange", {
          routeId: "approveDetail",
          routeParam: memberData,
        });
      });
    },
    //上传合同扫描件
    uploadContractFile() {
      if (this.selectItems.length != 1) {
        this.$alert("请选择一条数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      this.isImportContractDialog = false;
      this.showUploadDialog = true;
    },
    //关闭导入总包合同对话框
    closeDialogAction() {
      this.showUploadDialog = false;
    },
    closeDialog() {
      this.showExportDialog = false;
    },
    moreScreen() {
      this.showAdvanceFilter = !this.showAdvanceFilter;
      if (this.showAdvanceFilter) {
        this.tableHeight = this.$refs.main.$el.offsetHeight - 144 - 10;
      } else {
        this.tableHeight = this.$refs.main.$el.offsetHeight + 144 - 10;
      }
    },
  },
};
</script>
<style scoped >
/deep/.el-tabs__header {
  padding-right: 0 !important;
  background: #d5e7ed !important;
}
>>> .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: #fff;
  color: #069dbc !important;
  border-bottom-color: #e4e7ed;
}
>>> .el-tabs__item:hover {
  color: #069dbc;
}
</style>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.el-container {
  padding-top: 0;
  .el-header {
    padding: 0;
    form {
      padding-right: 20px;
    }
  }
}
.serviceContractMag {
  height: 100%;
  background-color: white;
}
/deep/.el-tabs__header {
  padding-right: 0 !important;
  background: #d5e7ed !important;
}
.el-select {
  width: 100%;
}
.hide {
  display: none;
}

/deep/.overTimeMark {
  background-color: #e9f4fa;
  .el-tooltip {
    color: #333333;
  }
}

/deep/.el-form-item__content {
  width: 60%;
}
/deep/.el-form-item {
  width: 100%;
}
/deep/.el-date-editor {
  width: 100% !important;
}
/deep/.el-button--primary {
  padding: 10px 3px;
}
@media screen and (max-width: 1366px) {
  /deep/.el-button--primary {
    min-width: 90px;
  }
}
</style>
